import { debounce } from '../../utils/debounce'
import BaseComponent from '../base-component/base-component'

class ScrollingTextLine extends BaseComponent {
  initialScreenWidth: number
  announcementSelector: string
  animationClass: string
  screenSizeMultiply: number
  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.initialScreenWidth = 0
    this.screenSizeMultiply = 2

    this.announcementSelector = '[data-scrolling-text-line]'
    this.animationClass = 'scrolling-text--animated'

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(document.body)
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  getDimentions = (): { screenWidth: number; announcementWidth: number } => {
    const announcement = this.querySelector(this.announcementSelector)

    if (!announcement) {
      return
    }

    const screenWidth = document.body.clientWidth
    const announcementWidth = announcement.clientWidth

    this.initialScreenWidth = screenWidth

    return { screenWidth, announcementWidth }
  }

  calcQuantityToRender = (
    screenWidth: number,
    announcementWidth: number,
  ): number => {
    return Math.round(
      (screenWidth * this.screenSizeMultiply) / announcementWidth,
    )
  }

  renderNodes = (blocksNumberToRender: number): void => {
    const announcement = this.querySelector(this.announcementSelector)

    if (!announcement) {
      return
    }

    const fragment = document.createDocumentFragment()

    for (let i = 0; i < blocksNumberToRender; i++) {
      const clonedAnnouncement = announcement.cloneNode(true)

      clonedAnnouncement.classList.add(this.animationClass)

      fragment.appendChild(clonedAnnouncement)
    }

    announcement.classList.add(this.animationClass)

    this.appendChild(fragment)
  }

  handleResize = debounce((): void => {
    const screenWidth = document.body.clientWidth

    if (screenWidth > this.initialScreenWidth) {
      this.render()
    }

    this.setAttribute('data-is-rendered', 'true')
  }, 100)

  render = (): void => {
    const { screenWidth, announcementWidth } = this.getDimentions()
    const blocksNumberToRender = this.calcQuantityToRender(
      screenWidth,
      announcementWidth,
    )

    this.renderNodes(blocksNumberToRender)
  }
}

export default ScrollingTextLine
